/**
 * Returns `url` with the `email` query param removed, retaining every other
 * param and the hash. Used to keep PII out of analytics `destination` values.
 *
 * Handles absolute URLs and root-relative hrefs (`/path?...`). Anything that
 * isn't one of those is returned untouched, so it can never break a CTA.
 */
export function stripPiiParams(url: string): string {
  try {
    const absolute = new URL(url);
    absolute.searchParams.delete("email");
    return absolute.toString();
  } catch {
    // Not an absolute URL — fall through to the relative-path handling below.
  }

  if (url.startsWith("/")) {
    const relative = new URL(url, "http://placeholder.invalid");
    relative.searchParams.delete("email");
    return relative.pathname + relative.search + relative.hash;
  }

  return url;
}
